/*
* @Author: MiheevAV
* @Date:   2020-05-19 10:26:16
* @Last Modified by:   MiheevAV
* @Last Modified time: 2020-06-17 12:42:21
*/

$(document).on('click', '.filialModal', function(event) {
  var modal = $('#airportsModal');
  var filial = $(this);
  $.ajax({
    url: 'api.php',
    type: 'GET',
    dataType: 'json',
    data: {fid: filial.data('id'), func: "getFilialBlank"},
  })
  .done(function(data) {
    modal.find('.modal-title').text(filial.text());
    modal.find('.modal-body').html(data.blank);
    modal.modal('show');
    modal.attr('filialId',  filial.data('id'));

    if(data.responsible == 1) {
      $('#filialPersonUpdateBlank').show();
    }
  });
});

$(document).on('click', '#airportsModal #filialPersonUpdateBlank', function(event) {
  var modal = $('#airportsModal');
  var span = $('#filialPersonUpdateBlank').find('span');
  span.eq(0).hide();
  span.eq(1).show();

  $.ajax({
    url: 'api.php',
    type: 'GET',
    async: false,
    dataType: 'html',
    data: {fid: modal.attr('filialId'), func: "getFilialUpdateBlank"},
  })
  .done(function(data) {
    modal.find('.modal-body').html(data);
    span.eq(0).show();
    span.eq(1).hide();
    $('#filialPersonUpdateBlank').hide();
    $('#filialPersonUpdate').show();
  });
});

$(document).on('click', '.airportModal', function(event) {
  var modal = $('#airportsModal');
  var airport = $(this);

  $.ajax({
    url: 'api.php',
    type: 'GET',
    dataType: 'html',
    data: {fid: airport.data('icao'), func: "getAirportBlank"},
  })
  .done(function(data) {
    modal.find('.modal-title').text((airport.text().search('АУП') == -1 ? "Аэродром " : "") +airport.text());
    modal.find('.modal-print').show().attr('href', 'api.php?fid='+airport.data('icao')+'&func=getAirportBlank&print=1');

    modal.find('.modal-body').html(data);
    modal.modal('show');
  });
});

$(document).on('click', '#filialPersonUpdate', function(){
  var modal = $('#airportsModal');
  var span = $('#filialPersonUpdateBlank').find('span');
  span.eq(0).hide();
  span.eq(1).show();
  $.ajax({
    url: 'api.php',
    type: 'POST',
    dataType: 'html',
    data: {fid: modal.attr('filialId'), func: "filialPersonUpdate", data: $('#filialBlank').serialize()},
  })
  .done(function(data) {
    modal.find('.modal-body').html(data);
    span.eq(0).show();
    span.eq(1).hide();
    $('#filialPersonUpdateBlank').show();
    $('#filialPersonUpdate').hide();
  });
});

$(document).on('#airportsModal hidden.bs.modal', function () {
  $('#filialPersonUpdate').hide();
  $('#filialPersonUpdateBlank').hide();
  $('.modal-print').hide();
});
